import { baseInstance } from "src/api";

// Ошибку намеренно НЕ проглатываем: раньше здесь возвращался объект ошибки,
// и react-query считал запрос успешным — сбойный ответ кэшировался как профиль
// (со staleTime 24ч), а приложение считало пользователя авторизованным без
// данных. Пусть ошибка дойдёт до хука: он покажет фолбэк и повторит запрос.
export const getUser = async () => baseInstance.get(`user/`);

export const editUser = async (payload: FormData) => {
  try {
    return await baseInstance.patch("user/", payload);
  } catch (err: any) {
    return err;
  }
};

export const getSupportUrl = async (): Promise<string> => {
  try {
    const response = await baseInstance.get<{ support_url?: string }>("settings/support-url/");
    return response?.data?.support_url ?? "";
  } catch {
    return "";
  }
};

export type SocialLinks = {
  tiktok: string;
  instagram: string;
  youtube: string;
  telegram: string;
};

// Ссылки на соцсети для футера. Бэкенд сам отдаёт набор текущей версии сайта
// (ru/en) по заголовку Accept-Language. Пустая строка = ссылка не задана.
export const getSocialLinks = async (): Promise<SocialLinks | null> => {
  try {
    const response = await baseInstance.get<SocialLinks>("settings/social-links/");
    return response?.data ?? null;
  } catch {
    return null;
  }
};
